import React, { useState, useEffect } from 'react';
import SelectSearch from 'react-select-search';
import { get } from './axios_call';

const useSelect = (props) => {
  const [options, setOptions] = useState(true);
  useEffect(() => {
    let sourceOuter;
    get('all_representatives', false)
      .then(([res, source]) => {
        sourceOuter = source;
        setOptions(
          <SelectSearch
            options={res.data.options}
            name="language"
            placeholder="search"
            search
            onChange={(e) => { props.history.push(e); }}
          />,
        );
      });
    return () => {
      sourceOuter.cancel();
      setOptions(null);
    };
  }, [props]);
  return options;
};

export default useSelect;
